import { render, staticRenderFns } from "./ModalReloadPage.vue?vue&type=template&id=d2655a66&scoped=true"
import script from "./ModalReloadPage.vue?vue&type=script&lang=js"
export * from "./ModalReloadPage.vue?vue&type=script&lang=js"
import style0 from "./ModalReloadPage.vue?vue&type=style&index=0&id=d2655a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2655a66",
  null
  
)

export default component.exports